import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { usePermissions, ModuleEnum, PermissionType } from 'contexts/auth/permission_context';

interface InstitutionCardActionsProps {
  uuid: string;
}

const InstitutionCardActions: React.FC<InstitutionCardActionsProps> = ({
  uuid,
}) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const hasAnyAction =
    hasPermission(ModuleEnum.INSTITUTIONS, PermissionType.READ) ||
    hasPermission(ModuleEnum.INSTITUTIONS, PermissionType.UPDATE);

  if (!hasAnyAction) return null;

  return (
    <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: '16px', paddingTop: '8px' }}>
      <Button variant='outlined' endIcon={<ArrowDropDownIcon />} sx={{ color: '#0048B6', border: '1px solid #0048B6', fontSize: '15px' }} onClick={handleClick}>
        Ações
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {hasPermission(ModuleEnum.INSTITUTIONS, PermissionType.READ) && (
          <MenuItem onClick={() => navigate(ROUTES.INSTITUTION_VIEW.replace(':uuid', uuid))} sx={{ fontSize: '15px' }}>
            Visualizar
          </MenuItem>
        )}
        {hasPermission(ModuleEnum.INSTITUTIONS, PermissionType.UPDATE) && (
          <MenuItem onClick={() => navigate(ROUTES.INSTITUTION_EDIT.replace(':uuid', uuid))} sx={{ fontSize: '15px' }}>
            Editar
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};

export default InstitutionCardActions;
